import { useQuery } from '@tanstack/react-query';

import { backendApis } from '@/backendApis';

export const referralKeys = {
  all: ['referral'] as const,
  code: () => [...referralKeys.all, 'code'] as const,
  stats: () => [...referralKeys.all, 'stats'] as const,
};

export function useReferralCodeQuery() {
  return useQuery({
    queryKey: referralKeys.code(),
    queryFn: async () => {
      try {
        return await backendApis.referral.getCode();
      } catch {
        return undefined;
      }
    },
  });
}

export function useReferralStatsQuery() {
  return useQuery({
    queryKey: referralKeys.stats(),
    queryFn: async () => {
      try {
        return await backendApis.referral.getStats();
      } catch {
        return undefined;
      }
    },
  });
}
